import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./SentTab.module.scss"
import ProgressBar from 'components/shared/ProgressBar/ProgressBar';
import { ReactComponent as Delete_Icon } from "assets/svg/Delete_Icon.svg"
import { NewTable } from 'components/shared/commonTable/Table';
import { clearAnnouncements, fetchannouncementList, setAnnpuncementsSentPagination } from 'redux/slices/announcementSlice';
import dayjs from 'dayjs';
import { Chip, Tooltip } from '@mui/material';
import DeleteModal from 'components/shared/deleteModal/DeleteModal';
import { ANNOUNCEMENT } from 'services/apiEndpoints';
import { getUserAccess } from 'utils/utils';
import { permissionsDenied } from 'utils/permission';



const SentTab = () => {
    const { totalCount, status, limit, pageNumber } = useSelector(
        (state) => state.announcement.announcementsSent
    );
    const { announcements } = useSelector(
        (state) => state.announcement
    );
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState({});



    const column = useMemo(() => {
        return (
            [
                {
                    name: "Title",
                    selector: row =>
                        <Tooltip
                            disableInteractive
                            title={row.title}
                        >
                            {row.title}
                        </Tooltip>
                },
                {
                    name: "Sent By",
                    selector: row =>
                        <Tooltip
                            disableInteractive
                            title={`${row.createdBy?.firstName} ${row.createdBy?.lastName}`}
                        >
                            {`${row.createdBy?.firstName} ${row.createdBy?.lastName}`}
                        </Tooltip>
                },
                {
                    name: "Status",
                    selector: () => <Chip
                        size="small"
                        sx={{
                            backgroundColor: 'rgb(51, 204, 153)',
                            color: 'white',
                            fontSize: "14px"
                        }}
                        label="Sent" />
                },
                {
                    name: "Date Sent",
                    selector: row => row?.createdAt && dayjs(row.deliveryOptions?.notification?.scheduledTime).format('MMMM D, h:mm A [GMT]Z'),
                    grow: 2
                },
                {
                    name: "Recipients",
                    selector: row => row.recipientsStatus?.length,
                },
                {
                    name: "Open Count",
                    selector: row => row?.openedCount,
                },
                {
                    name: "Open Rate",
                    selector: row => {
                        const openedRate = Math.floor((row?.openedCount / row?.recipientsStatus?.length) * 100);
                        return (
                            <div className={styles.openRate}>
                                <p>{openedRate}% Opened</p>
                                <ProgressBar percentage={openedRate} />
                            </div>
                        )
                    }
                },
                ...(!permissionsDenied[getUserAccess()]?.includes("deleteSentAnnouncement") ?
                    [
                        {
                            name: "Action",
                            selector: row => <Delete_Icon onClick={(e) => handleDeleteIcon(e, row)} className={styles.optionsIcon} />
                        }
                    ]
                    :
                    []
                )
            ]
        )
    }, [])

    const handleDeleteIcon = (e, row) => {
        e.stopPropagation()
        setSelectedAnnouncement(row);
        setDeleteModalOpen(true);
    };

    const handlePageChange = (page) => {
        dispatch(setAnnpuncementsSentPagination({ limit, pageNumber: page }))
    }

    const handlePerRowsChange = (perPage) => {
        dispatch(setAnnpuncementsSentPagination({ limit: perPage, pageNumber: 1 }))
    };

    const onAfterEditOrDelete = () => {
        dispatch(fetchannouncementList({ limit, pageNumber, type: 'notification', notificationType: "sent" }))
    }

    useEffect(() => {
        // limit=5&pageNumber=1&type=notification&notificationType=scheduled&recipientType=user   
        dispatch(fetchannouncementList({ limit, pageNumber, type: 'notification', notificationType: "sent" }))
        return () => {
            dispatch(clearAnnouncements())
        }
    }, [limit, pageNumber]);

    return (
        <div className={styles.SentTabContainer}>
            <div className={styles.dataContainer}>
                <NewTable
                    columns={column}
                    data={announcements}
                    onRowClicked={
                        (row) => {
                            navigate(`/announcements/${row?._id}`, { state: { type: "immediate" } })
                        }
                    }
                    progressPending={status === "loading"}
                    paginationTotalRows={totalCount}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    pagination
                    paginationServer
                />
            </div>
            <DeleteModal
                modalOpen={deleteModalOpen}
                setModalOpen={setDeleteModalOpen}
                getData={onAfterEditOrDelete}
                selected={selectedAnnouncement}
                setSelected={setSelectedAnnouncement}
                heading={"Announcemnet"}
                endPoint={ANNOUNCEMENT}
            />
        </div>
    )
}

export default SentTab
